module.exports = __webpack_public_path__ + "img/Logo-33.9ca78968.svg";